import i18n from "@/lang";

export class TagKeyConverter {
    static tagKeyMapping = {
        cpu_type: "knownTagKeys.cpu_type",
        os_version: "knownTagKeys.os_version",
        disk_size_gb: "knownTagKeys.disk_size_gb",
        ram_size_gb: "knownTagKeys.ram_size_gb",
        board_type: "knownTagKeys.board_type",
        "PC Board": "knownTagKeys.board_type",
    };

    static isKnownTag(source: string): boolean {
        const res = this.tagKeyMapping[source] != undefined;
        return res;
    }

    static convert(source: string): string {
        if (this.isKnownTag(source)) {
            return i18n.t(this.tagKeyMapping[source]).toString();
        }

        return source;
    }
}
